const customFontsize = (min, max) => {
  const minFontSize = min / 16
  const maxFontSize = max / 16
  const maxWidth = 1024 / 16
  const minWidth = 768 / 16

  const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth)
  const yAxisIntersection = -minWidth * slope + minFontSize
  return `clamp(${minFontSize}rem, ${yAxisIntersection}rem + 
    ${slope * 100}vw, ${maxFontSize}rem)`
}

export default {
  customFontsize,
  breakpoints: ['32em', '80em'],
  sizes: {
    container: 1180
  },
  space: [
    0,
    4,
    8,
    12,
    16,
    20,
    24,
    28,
    32,
    36,
    40,
    44,
    48,
    52,
    56,
    60,
    64,
    68,
    72,
    76,
    80,
    84,
    88,
    92,
    96,
    100,
    104,
    108,
    112,
    116,
    120,
    124,
    128,
    132,
    136,
    140,
    144,
    148,
    152,
    156,
    160
  ],
  colors: {
    purple: '#7739EB',
    purple2: '#391F6A',
    purple3: '#823BF8',
    purple4: '#8F53FF',
    lightPurple: '#F7F4FE',
    lightPurpleGray: '#E6EBF0',
    black: '#2C2C52',
    darkGray: '#435565',
    gray: '#707495',
    darkBlue: '#0A2540',
    blue: '#0079DB',
    blueGray: '#EFE7FD',
    lightBlue: '#F5F0FF',
    green: '#8AC55F',
    pink: '#FFCAE6',
    pink2: '#EB3999',
    lightGray: '#FAF8FC',
    red: '#EB3959',
    wine: '#994477',
    white: '#FFFFFF'
  },
  text: {
    level1: {
      fontSize: customFontsize(42, 56),
      fontWeight: '600',
      fontFamily: 'Poppins, Sans-Serif',
      lineHeight: '120%',
      letterSpacing: '-1.5px',
      color: '#0A2540'
    },
    level2: {
      fontSize: customFontsize(36, 40),
      fontWeight: '600',
      fontFamily: 'Poppins, Sans-Serif',
      lineHeight: '130%',
      letterSpacing: '-0.5px',
      color: '#0A2540'
    },
    level3: {
      fontSize: customFontsize(24, 32),
      fontWeight: '600',
      fontFamily: 'Poppins, Sans-Serif',
      lineHeight: '110%',
      letterSpacing: '0.25px',
      color: '#0A2540'
    },
    level4: {
      fontSize: customFontsize(14, 20),
      fontWeight: '400',
      fontFamily: 'Relaway, Sans-Serif',
      lineHeight: '180%',
      letterSpacing: '0.15px',
      color: '#435565'
    },
    level5: {
      fontSize: customFontsize(14, 18),
      fontWeight: '400',
      fontFamily: 'Relaway, Sans-Serif',
      lineHeight: '180%',
      letterSpacing: '0.15px',
      color: '#435565'
    },
    level6: {
      fontSize: customFontsize(14, 16),
      fontWeight: '400',
      fontFamily: 'Relaway, Sans-Serif',
      lineHeight: '170%',
      letterSpacing: '0.15px',
      color: '#435565'
    },
    link: {
      fontSize: customFontsize(12, 14),
      fontWeight: '400',
      fontFamily: 'Poppins, Sans-Serif',
      lineHeight: '18px',
      letterSpacing: '0.5px',
      color: '#435565',
      transition: 'all .2s ease-in-out',

      '&:hover': {
        opacity: 0.6
      }
    }
  },
  buttons: {
    primary: {
      bg: 'purple',
      height: '55px',
      border: '1px solid',
      borderColor: 'purple',
      borderRadius: '70px',
      boxShadow: '0px 14px 34px rgba(119, 57, 235, 0.3)',
      fontSize: '15px',
      fontFamily: 'Poppins,Sans-Serif',
      fontWeight: '600',
      color: 'white',
      cursor: 'pointer',
      transition: 'all .2s ease-in-out',

      '&:hover': {
        color: 'purple',
        bg: 'transparent'
      }
    },
    secondary: {
      bg: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      border: '1px solid',
      borderColor: 'purple3',
      borderRadius: '70px',
      fontSize: '12px',
      fontFamily: 'Poppins,Sans-Serif',
      fontWeight: '500',
      color: 'purple',
      cursor: 'pointer',
      transition: 'all .2s ease-in-out',

      '&:hover': {
        color: 'white',
        bg: 'purple'
      }
    },
    tertiary: {
      bg: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '145px',
      height: '60px',
      borderRadius: '70px',
      boxShadow: '0px 14px 34px rgba(119, 57, 235, 0.12)',
      fontSize: '15px',
      lineHeight: '23px',
      fontFamily: 'Poppins,Sans-Serif',
      fontWeight: '600',
      letterSpacing: '0.5px',
      color: 'purple',
      cursor: 'pointer',
      transition: 'all .2s ease-in-out',

      '&:hover': {
        color: 'white',
        bg: 'purple'
      }
    },
    quartiary: {
      bg: 'rgba(130, 59, 248, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '160px',
      height: '55px',
      borderRadius: '70px',
      fontSize: '15px',
      lineHeight: '23px',
      fontFamily: 'Poppins,Sans-Serif',
      fontWeight: '600',
      color: 'purple',
      cursor: 'pointer',
      transition: 'all .2s ease-in-out',

      '&:hover': {
        color: 'white',
        bg: 'purple'
      }
    },
    fifth: {
      bg: 'transparent',
      border: 'none',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
      color: 'purple',
      cursor: 'pointer',
      transition: 'all .2s ease-in-out',
      '&:hover': {
        opacity: '0.5'
      }
    },
    sixth: {
      bg: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '145px',
      height: '60px',
      borderRadius: '70px',
      fontSize: '15px',
      lineHeight: '23px',
      fontFamily: 'Poppins,Sans-Serif',
      fontWeight: '600',
      letterSpacing: '0.5px',
      color: 'purple4',
      cursor: 'pointer'
    }
  }
}
